// import axios from 'axios'
import axios from "axios";
const nameApiTicket = "ticket";

export default {
  // get all (complains types) of ticket
  async complainsTypes({ commit }) {
    const response = await axios.get(`${nameApiTicket}/complains-types`);
    commit("SET_TYPES", response.data.feed);
    commit("SET_SUCCESS", response.data.success);
    commit("SET_ERROR_MSG", response.data.error_msg);
  },

  // get all (inquiries types) of ticket
  async inquiriesTypes({ commit }) {
    const response = await axios.get(`${nameApiTicket}/inquiries-types`);
    commit("SET_TYPES", response.data.feed);
    commit("SET_SUCCESS", response.data.success);
    commit("SET_ERROR_MSG", response.data.error_msg);
  },


  // get all tickets
  async allTickets({ commit }, credentials) {
    const response = await axios.get(
      `${nameApiTicket}/get?status=${credentials.statusTicket}&page=${credentials.page}&id=${credentials.id}&seen_by_client=${credentials.isRead}`
    );
    commit("SET_TICKETS", response.data.feed.data);
    commit("SET_SUCCESS", response.data.success);
    commit("SET_ERROR_MSG", response.data.error_msg);
  },

  // get ticket details
  async singleTicket({ commit }, credentials) {
    const response = await axios.get(
      `${nameApiTicket}/show?ticket_id=${credentials}`
    );
    commit("SET_SINGLE_TICKET", response.data.feed);
    commit("SET_REPLIES_TICKET", response.data.feed.replies);
    commit("SET_ASSIGNED_USER", response.data.feed.assigned_user);
  },


  // git log of ticket
  async logTicket({ commit }, credentials) {
    const response = await axios.get(
      `${nameApiTicket}/log?ticket_id=${credentials}`
    );
    commit("SET_SUCCESS", response.data.success);
    commit("SET_ERROR_MSG", response.data.error_msg);
    commit("SET_TICKET_LOG", response.data.feed.logs);
  },

  // get number of unread messages for ticket chat
  async countUnreadTicket({ commit }) {
    const response = await axios.get(`${nameApiTicket}/unreaded_tickets`);
    commit("SET_SUCCESS", response.data.success);
    commit("SET_ERROR_MSG", response.data.error_msg);
    commit("SET_COUNT_UNREAD_TICKET", response.data.feed);
  },


  // to show&hide ticket popup
  toggleShowTicket({ commit, state }) {
    if (state.showType) commit("SET_SHOW_TYPE", false);
    else commit("SET_SHOW_TYPE", true);
  },

  // to find which page the client is on
  setTicketPageIndex({ commit }, ticketPageIndex) {
    commit("SET_COUNT", ticketPageIndex);
  },

  // to change page index
  nextPage({ commit }) {
    commit("SET_NEXT_PAGE");
  },
  previousPage({ commit }) {
    commit("SET_PREVIOUS_PAGE");
  },

  // to save type problem of ticket
  setTypeProblem({ commit }, type) {
    commit("SET_TYPE_PROBLEM", type);
  },

  // to default setting (page index = 1 & type problem = null)
  newTicket({ commit }) {
    commit("SET_NEW_TICKET");
  },

  // to save sub title of ticket
  setSubTitle({ commit }, subTitle) {
    commit("SET_SUB_TITLE", subTitle);
  },

  // to save id of complain type
  setComplainTypeId({ commit }, complainTypeId) {
    commit("SET_COMPLAINT_TYPE_ID", complainTypeId);
  },

  // to save id of (complain type title)
  setComplainTypeTitleId({ commit }, complainTypeTitleId) {
    commit("SET_COMPLAIN_TYPE_TITLE_ID", complainTypeTitleId);
  },

  // to save type of ticket
  setTypeTicket({ commit }, typeTicket) {
    commit("SET_TYPE_TICKET", typeTicket);
  },

  // to save related model (if type of ticket complain) - (complain related with order or branch or mission or ...)
  setRelatedModel({ commit }, relatedModel) {
    commit("SET_RELATED_MODEL", relatedModel);
  },

  // to save id of inquiry type
  setInquiryTypeId({ commit }, inquiryTypeId) {
    commit("SET_INQUIRY_TYPE_Id", inquiryTypeId);
  },

  // to save entityId (if type of ticket complain)
  // if complain related with order so entityId = id of order
  // if complain related with branch so entityId = id of brnch
  // if complain related with order so entityId = id of mission
  // ...
  setEntityId({ commit }, entityId) {
    commit("SET_ENITY_ID", entityId);
  },

  // to save not delay (with copmlain in order)
  // to save this order not delayed
  setNotDelay({ commit }) {
    commit("SET_NOT_DELAY", false);
  },

  // get instructions of ticket
  async gitInstructions({ commit }) {
    await axios
      .get(`${nameApiTicket}/ticket-instructions`)
      .then((res) => {
        if (res.status == 200) {
          commit("SET_TICKET_INSTRUCTIONS", res.data.feed);
          commit("SET_ERR_INSTRUCTIONS", "");
        }
      })
      .catch((err) => {
        commit("SET_ERR_INSTRUCTIONS", err.message);
      });
  },
};
